<template>
  <v-dialog v-model="dialog" content-class="v-dialog--custom"
    :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card>
      <v-card-title class="headline">{{ titleForm }}</v-card-title>
      <v-card-text>
        <v-container>
          <alert-message />
          <v-row>
            <v-col>
              {{ message }}
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeDelete">Cancel</v-btn>
        <v-btn
          :class="buttonClass"
          text
          @click="deleteItemConfirm"
          :loading="loading"
          >{{ buttonLabel }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import UTIL from "src/helpers/utility";
import AlertMessage from "src/components/AlertMessage";

export default {
  props: {
    title: String,
    buttonLabel: String,
    buttonClass: String,
    message: String,
    status:String,
    item: [Object, String],
    show: [Boolean, String],
  },
  components: {
    AlertMessage,
  },
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      quote: (state) => state.quote,
      alert: (state) => state.alert,
      account: (state) => state.account,
    }),

    titleForm() {
      return `${this.title} `.replace("{id}", `#${this.item.id}`);
    },

    name() {
      return UTIL.gv(this.item, "id");
    },
  },
  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },
  },
  methods: {
    ...mapActions("quote", ["confirm"]),
    ...mapActions({
      'convertItemsToTask': 'quote/convertItemsToTask',
      'createTask': 'task/create'
    }),
    closeDelete() {
      this.dialog = false;
      this.$store.dispatch("alert/clear");
      this.$emit("onClosed");
    },

    async deleteItemConfirm() {
      // const lineItemsWithId = this.item.lineItems.map(item => {
      //   return {
      //     task: {
      //       clientId: this.item.clientId,
      //       name: item.title,
      //       date: item.date,
      //       type: item.type,
      //       rate: item.price,
      //       description: item.description,
      //       status: 'open'
      //     },
      //     userIds: [this.account.data.user.id]
      //   }
      // });

      // const lineItems = this.item.lineItems.map(item => {
      //   delete item.id;
      //   return {
      //     ...item
      //   }
      // });

      

      this.loading = true;
      let confirmValue = this.status === 'approved' ? true : false;

      const payload = {
        id: this.item.id,
        value: confirmValue
      };
      await this.confirm(payload);
      if (!this.quote.status.error) {
        if (this.status === 'approved') {
          // await this.convertItemsToTask(lineItemsWithId);
          // lineItemsWithId.map(async (item) => await this.createTask(item));
        }
        this.closeDelete();
        this.$emit("onSucceded");
      }
      this.loading = false;
    },
  },
};
</script>